/*=========================================================================================
  File Name: moduleCityMutations.js
  Description: City Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ADD_ITEM(state, item) {
    state.cities.unshift(item)
  },
  SET_City(state, cities) {
    state.cities = cities
  },
  UPDATE_City(state, City) {
    const CityIndex = state.cities.findIndex((p) => p.ID == City.ID)
    Object.assign(state.cities[CityIndex], City)
},
REMOVE_ITEM(state, itemId) {
    const ItemIndex = state.cities.findIndex((p) => p.ID == itemId)
    state.cities.splice(ItemIndex, 1)
},
}
